// Meta (Facebook) Pixel integration
// Pixel ID: 1020406927053977

export const FB_PIXEL_ID = '1020406927053977'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

/**
 * Injects the official Meta Pixel base code and initializes the pixel.
 * Safe to call once on app start. Fires the initial PageView.
 */
export function initFbPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq)
    return // already initialized
    /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', FB_PIXEL_ID)
  window.fbq('track', 'PageView')
}

/**
 * Track a standard Meta Pixel event.
 * @param event Standard event name (e.g. 'ViewContent', 'InitiateCheckout')
 * @param data  Optional event parameters
 */
export function trackFb(event: string, data?: Record<string, any>): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, data)
}
